import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startReport1071Status: 'idle',
    startReport1071Error: undefined as any,
    loadUserParamsReport1071Status: 'idle',
    loadUserParamsReport1071Error: undefined as any,

    report1071List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startReport1071 = createAsyncThunk('report1071Slice/startReport1071', async ({ report1071 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartReport1071/`,
        prepareData(report1071),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startReport1071Status } = getState().report1071Slice
        return startReport1071Status !== 'pending'
    }
})

export const loadUserParamsReport1071 = createAsyncThunk('report1071Slice/loadUserParamsReport1071', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsReport1071/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsReport1071Status } = getState().report1071Slice
        return loadUserParamsReport1071Status !== 'pending'
    }
})

const Report1071Slice = createSlice({
    name: 'report1071Slice',
    initialState,
    reducers: {
        resetstartReport1071: (state) => {
            state.job = undefined
            state.startReport1071Error = undefined
        },
        resetstartReport1071Error: (state) => {
            state.startReport1071Error = undefined
        },
        resetloadUserParamsReport1071: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsReport1071Error = undefined
        },
        resetloadUserParamsReport1071Error: (state) => {
            state.loadUserParamsReport1071Error = undefined
        },
        removeFromReport1071ListById: (state, action) => {
            state.report1071List = state.report1071List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromReport1071ListByIds: (state, action) => {
            state.report1071List = state.report1071List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.report1071List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startReport1071Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.report1071List = []
            state.startReport1071Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startReport1071.pending, (state) => {
            state.startReport1071Status = 'pending'
            state.startReport1071Error = undefined
        })
        builder.addCase(startReport1071.fulfilled, (state, action) => {
            state.startReport1071Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startReport1071.rejected, (state, action) => {
            state.startReport1071Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startReport1071Error = action.error.message
            } else {
                state.startReport1071Error = action.payload
            }
        })

        builder.addCase(loadUserParamsReport1071.pending, (state) => {
            state.loadUserParamsReport1071Status = 'pending'
            state.loadUserParamsReport1071Error = undefined
        })
        builder.addCase(loadUserParamsReport1071.fulfilled, (state, action) => {
            state.loadUserParamsReport1071Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsReport1071.rejected, (state, action) => {
            state.loadUserParamsReport1071Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsReport1071Error = action.error.message
            } else {
                state.loadUserParamsReport1071Error = action.payload
            }
        })

    }
})

export const {
    resetstartReport1071,
    resetstartReport1071Error,
    resetloadUserParamsReport1071,
    resetloadUserParamsReport1071Error,
    removeFromReport1071ListById,
    removeFromReport1071ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Report1071Slice.actions
export default Report1071Slice.reducer
